export const ACTION_SET_LOADER = 'ACTION_SET_LOADER';
export const ACTION_RESET_LOADER_STORE = 'ACTION_RESET_LOADER_STORE';

export enum LoaderType {
    Default,
    HamsterWheel,
    SuccessPageUpload,
    SuccessCheckout,
    YatHandLoader,
    YatV2Loader,
}

export interface LoaderState {
    open: boolean;
    counter: number;
    type?: LoaderType;
}

export interface NewLoaderState {
    open: boolean;
    type?: LoaderType;
    source?: string;
}

interface SetLoaderState {
    type: typeof ACTION_SET_LOADER;
    state: NewLoaderState;
}

interface ResetLoaderState {
    type: typeof ACTION_RESET_LOADER_STORE;
}

export type LoaderActionTypes = SetLoaderState | ResetLoaderState;

export const DEFAULT: LoaderState = {
    open: false,
    counter: 0,
    type: LoaderType.YatHandLoader,
};
